<template>
  <v-dialog v-model="dialog" scrollable persistent width="800px">
    <v-card>
      <v-card-title class="blue darken-4 white--text">
        <span class="text-center headline"> Seleccionar Unidades </span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="unidades"
            :single-select="singleSelect"
            :loading="loadingunidades"
            disable-pagination
            hide-default-footer
            item-key="id"
            show-select
            class="elevation-1"
          >
          </v-data-table>
        </v-container>

        <p class="text-center red--text">{{ msg }}</p>
        <v-progress-linear indeterminate v-if="loading" />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" rounded outlined @click="enviarSeleccionados()">
          <v-icon class="mx-1">mdi-content-save</v-icon> Aceptar
        </v-btn>
        <v-btn rounded outlined @click="cleartipo()"> <v-icon>mdi-close</v-icon> Cancelar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import gql from 'graphql-tag';
  export default {
    data() {
      return {
        dialog: false,
        loading: false,
        loadingunidades: false,
        msg: '',
        unidades: [],
        singleSelect: false,
        selected: [],
        headers: [
          //   { text: '#', value: 'index' }
          { text: 'Unidad', value: 'nombre' },
        ],
      };
    },
    computed: {},
    watch: {},
    methods: {
      openmodal() {
        this.dialog = true;
        this.selected = [];
        this.unidades = [];
        this.getunidades();
      },
      enviarSeleccionados() {
        this.$emit('unidades_sel', this.selected);
        this.dialog = false;
      },
      cleartipo() {
        this.$emit('cleartipo');
        this.dialog = false;
      },
      async getunidades() {
        var vue = this;
        this.loadingunidades = true;
        this.unidades = [];
        let s = `query { NegociosAll { id nombre } }`;
        var sql = gql`
          ${s}
        `;
        await this.$apollo
          .query({
            query: sql,
          })
          .then((data) => {
            var dat = data.data.NegociosAll;
            /*  dat.map((x) => {
              x.text = x.nombre;
            }); */
            vue.unidades = dat;
            vue.loadingunidades = false;
          })
          .catch((error) => {
            vue.loadingunidades = false;
            window.console.error(error);
          });
      },
    },
  };
</script>
